import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode; onExit: () => void }
interface State { error: Error | null }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Game cabinet crashed', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <section className="game-crash" role="alert">
        <span className="eyebrow">Cabinet fault</span>
        <h2>The machine ate a coin.</h2>
        <p>Your save is safe. Return to the arcade and try the cabinet again.</p>
        <button className="button button--ink" onClick={this.props.onExit}>Back to arcade</button>
      </section>
    );
  }
}
